<template>
  <v-row density="compact">
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.high_low"
        density="compact"
        :items="high_low"
        label="New High or New Low"
        variant="outlined"
        hide-details
        @update:model-value="updateConfig('high_low', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.days"
        density="compact"
        :items="days_time_periods"
        label="# of days for new high/low"
        variant="outlined"
        hide-details
        @update:model-value="updateConfig('days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.increased_price_percent"
        density="compact"
        label="% change in price"
        hint="optionally set the percentage over the previous high/low the new high/low price must be"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('increased_price_percent', $event)"
      />
    </v-col>
    <v-col cols="12">
      <p>
        Optionally require a previous breakout (up or down) within the past __ days before accepting
        the signal
      </p>
      <p>
        For example, requiring a previous breakout would let you make the rule: buy Stock A if it
        makes a 1 week high after having made a 4 week low within the past 10 days. Or buy a 1 week
        low if it made a 90 day high within the past 10 days.
      </p>
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <v-select
        :model-value="rule.config.previous_breakout_high_low"
        :items="high_low"
        label="High or New Low"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('previous_breakout_high_low', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <v-select
        :model-value="rule.config.previous_breakout_days"
        :items="days_time_periods"
        label="# of days"
        hint="Previous breakout  # days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('previous_breakout_days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        :model-value="rule.config.previous_breakout_past_days"
        density="compact"
        hide-details
        variant="outlined"
        hint="breakout occured within the past __ days"
        label="occurred within # days"
        @update:model-value="updateConfig('previous_breakout_past_days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-checkbox
        :model-value="rule.config.increased_volume"
        density="compact"
        label="Must also have increase in trading volume"
        @update:model-value="updateConfig('increased_volume', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        :model-value="rule.config.increased_volume_percent"
        density="compact"
        hide-details
        variant="outlined"
        label="% increase in volume"
        @update:model-value="updateConfig('increased_volume_percent', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.volume_avg_days"
        density="compact"
        hide-details
        variant="outlined"
        :items="volume_time_periods"
        label="Avg Volume Time Period"
        @update:model-value="updateConfig('volume_avg_days', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
// Modules
import { mapFields } from '@/store/helpers'

export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      high_low: ['new high', 'new low'],
      volume_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '90 Days', value: 90 }
      ],
      days_time_periods: [
        { text: '1 week', value: 7 },
        { text: '2 weeks', value: 14 },
        { text: '3 weeks', value: 21 },
        { text: '4 weeks', value: 28 },
        { text: '50 days', value: 50 },
        { text: '90 days', value: 90 },
        { text: '6-months', value: 180 },
        { text: '1 Year', value: 365 }
      ],
      editedIndex: -1,
      editedPrice: {
        rule_type: 'breakout',
        long_short: 'long',
        high_low: 'high',
        days: 0,
        allocation: 0,
        increased_price_percent: 0,
        increased_volume: false,
        increased_volume_percent: 0,
        volume_avg_days: 0,
        previous_breakout_high_low: null,
        previous_breakout_days: null,
        previous_breakout_past_days: null,
        enabled: true
      },
      defaultPrice: {
        rule_type: 'breakout',
        long_short: 'long',
        high_low: 'high',
        days: 20,
        allocation: 100,
        increased_price_percent: 0,
        increased_volume: false,
        increased_volume_percent: 5.0,
        volume_avg_days: 0,
        previous_breakout_high_low: null,
        previous_breakout_days: null,
        previous_breakout_past_days: null,
        enabled: true
      }
    }
  },

  computed: {
    ...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.trend_signal',
      enabled: 'app.whaleTraderCriteria.signals.trend_signal.enabled',
      signalView: 'app.signalView',
      exit_time_periods: 'app.exit_time_periods'
    })
  },

  watch: {},

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'breakout') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultPrice) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
